<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <Dialog as="div" class="relative z-10" >
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
                       leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
      </TransitionChild>

      <div class="fixed z-10 inset-0 overflow-y-auto">
        <div class="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300"
                           enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                           enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
                           leave-from="opacity-100 translate-y-0 sm:scale-100"
                           leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
                class="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-sm sm:w-full sm:p-6">
              <div>
                <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                  <CheckIcon class="h-6 w-6 text-green-600" aria-hidden="true"/>
                </div>
                <div class="mt-3 text-center sm:mt-5">
                  <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900"> Importer une facture
                  </DialogTitle>
                  <div class="mt-2">
                    <p class="text-sm text-gray-500">Importer une facture rapidement et efficacement.</p>
                  </div>
                </div>
                <div class="mt-3 sm:mt-5">
                  <form action="" method="POST" @submit.prevent="postNow">
                    <div class="sm:col-span-3">
                      <label class="block text-sm font-medium text-gray-700"> Fournisseur <span class="text-gray-400">(optionnel — détection automatique)</span></label>
                      <div class="mt-1">
                        <Multiselect v-if="companys.length"
                                     v-model="invoiceData.company_id"
                                     placeholder="Select options"
                                     :options="companys"
                                     :create-option="true"
                                     label="label"
                                     valueProp="value"
                                     :allow-absent="true"
                                     :searchable="true"
                                     :object="false"
                                     :close-on-select="true"
                                     :min-chars="1"
                        >
                          <template v-slot:option="{ option }">
                            <img class="character-option-icon h-5 w-5 flex-shrink-0 rounded-full" :src="option.icon">
                            <span class="font-normal ml-3 block truncate">{{ option.label }}</span>
                          </template>
                        </Multiselect>


                      </div>
                    </div>
                    <div class="sm:items-start sm:pt-5">
                      <div class="mt-1 sm:mt-0 sm:col-span-2">
                        <div
                            :class="selectedFiles.length > 0 ? 'border-green-300 bg-green-50' : 'border-gray-300'"
                            class="max-w-lg flex justify-center px-6 pt-5 pb-6 border-2 border-dashed rounded-md"
                            @drop="handleDrop"
                            @dragover="handleDragover"
                            @dragenter="handleDragenter">
                          <div class="space-y-1 text-center w-full">
                            <!-- Icône upload par défaut -->
                            <svg v-if="selectedFiles.length === 0" class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none"
                                 viewBox="0 0 48 48" aria-hidden="true">
                              <path
                                  d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            
                            <!-- Liste des fichiers sélectionnés -->
                            <div v-if="selectedFiles.length > 0" class="space-y-2">
                              <svg class="mx-auto h-8 w-8 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clip-rule="evenodd" />
                              </svg>
                              <p class="text-sm font-medium text-green-700">{{ selectedFiles.length }} fichier(s) sélectionné(s)</p>
                              
                              <!-- Liste détaillée des fichiers -->
                              <div class="max-h-40 overflow-y-auto space-y-1">
                                <div v-for="(file, index) in selectedFiles" :key="index" 
                                     class="bg-white p-2 rounded border text-sm">
                                  <div class="flex items-center justify-between">
                                    <div class="flex items-center space-x-2 flex-1 min-w-0">
                                      <!-- Icône de statut -->
                                      <svg v-if="!uploadProgress[file.name] || uploadProgress[file.name].status === 'pending'" 
                                           class="h-4 w-4 text-red-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" clip-rule="evenodd" />
                                      </svg>
                                      <svg v-else-if="uploadProgress[file.name].status === 'uploading'" 
                                           class="h-4 w-4 text-blue-500 flex-shrink-0 animate-spin" fill="none" viewBox="0 0 24 24">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                      </svg>
                                      <svg v-else-if="uploadProgress[file.name].status === 'success'" 
                                           class="h-4 w-4 text-green-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                                      </svg>
                                      <svg v-else-if="uploadProgress[file.name].status === 'error'" 
                                           class="h-4 w-4 text-red-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                                      </svg>
                                      
                                      <span class="truncate text-gray-700 font-medium">{{ file.name }}</span>
                                      <span class="text-xs text-gray-500 flex-shrink-0">({{ formatFileSize(file.size) }})</span>
                                    </div>
                                    <button v-if="!isUploading" @click="removeFile(index)" 
                                            class="ml-2 text-red-500 hover:text-red-700 flex-shrink-0">
                                      <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                                      </svg>
                                    </button>
                                  </div>
                                  
                                  <!-- Statut d'upload -->
                                  <div v-if="uploadProgress[file.name]" class="mt-1 text-xs">
                                    <span v-if="uploadProgress[file.name].status === 'uploading'" class="text-blue-600">
                                      Envoi en cours...
                                    </span>
                                    <template v-else-if="uploadProgress[file.name].status === 'success'">
                                      <span v-if="uploadProgress[file.name].alreadyExists" class="text-amber-600">
                                        ⚠ Facture déjà existante
                                      </span>
                                      <span v-else class="text-green-600">
                                        ✓ Facture importée
                                      </span>
                                      <span v-if="uploadProgress[file.name].company" class="inline-flex items-center text-gray-600">
                                        —
                                        <img v-if="uploadProgress[file.name].company.avatar"
                                             :src="uploadProgress[file.name].company.avatar"
                                             class="h-3.5 w-3.5 rounded-full mx-1"/>
                                        {{ uploadProgress[file.name].company.name }}
                                      </span>
                                      <span v-else class="text-gray-400"> — fournisseur non détecté</span>
                                    </template>
                                    <span v-else-if="uploadProgress[file.name].status === 'error'" class="text-red-600">
                                      ✗ Erreur lors de l'import
                                    </span>
                                  </div>
                                </div>
                              </div>
                              
                              <label for="file-upload"
                                     class="cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                                <span class="underline">Ajouter d'autres fichiers</span>
                                <input id="file-upload" name="file" type="file" multiple class="sr-only" accept=".pdf"
                                       @change="handleFileUpload( $event )"/>
                              </label>
                            </div>
                            
                            <div v-else class="flex text-sm text-gray-600">
                              <label for="file-upload"
                                     class="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                                <span>Importez des fichiers</span>
                                <input id="file-upload" name="file" type="file" multiple class="sr-only" accept=".pdf"
                                       @change="handleFileUpload( $event )"/>
                              </label>
                              <p class="pl-1">ou déplacez les ici</p>
                            </div>
                            <p class="text-xs text-gray-500">PDF uniquement - Sélection multiple possible</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div class="mt-5 sm:mt-6">


                <button type="button"
                        :disabled="selectedFiles.length === 0 || isUploading"
                        :class="[
                          selectedFiles.length === 0 || isUploading 
                            ? 'bg-gray-400 cursor-not-allowed' 
                            : 'bg-indigo-600 hover:bg-indigo-700',
                          'inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm'
                        ]"
                        @click="postNow">
                  <svg v-if="isUploading" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  {{ isUploading ? 'Import en cours...' : `Importer ${selectedFiles.length > 0 ? selectedFiles.length + ' fichier(s)' : ''}` }}
                </button>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
</template>

<script setup>
import {CheckCircleIcon, ChevronRightIcon, MailIcon, ExclamationCircleIcon} from '@heroicons/vue/solid'
import {notify, Notification, NotificationGroup} from 'notiwind'
import {CreditCardIcon, OfficeBuildingIcon, SearchIcon, UserIcon, UsersIcon} from '@heroicons/vue/solid'
import {ref} from 'vue'
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {CheckIcon} from '@heroicons/vue/outline'
</script>

<script>
import {useFetch, usePostFile} from "@/composables/fetch";
import Multiselect from '@vueform/multiselect'


export default {
  components: {
    Multiselect,
  },
  props: {
    preselectedCompanyId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      companys: [],
      endpoint: "company",
      invoiceData: {
        company_id: null,
        files: []
      },
      selectedFiles: [],
      uploadProgress: {},
      isUploading: false
    }
  },
  mounted() {
    this.fetchCompanyData();
  },
  watch: {
    preselectedCompanyId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.invoiceData.company_id = newVal;
        }
      }
    }
  },
  methods: {
    async fetchCompanyData() {
      const token = await this.$auth.getAccessTokenSilently();
      const response = await useFetch(this.endpoint, token)
      const {companys} = response.data

      this.companys = companys.map(item => {
        return {
          label: item.name,
          value: item.id,
          icon: item.avatar
        }
      })
    },
    async postNow() {
      if (this.selectedFiles.length === 0) {
        alert('Veuillez sélectionner au moins un fichier');
        return;
      }

      this.isUploading = true;
      const token = await this.$auth.getAccessTokenSilently();
      let successCount = 0;

      for (let i = 0; i < this.selectedFiles.length; i++) {
        const file = this.selectedFiles[i];

        // Ne pas ré-importer un fichier déjà traité avec succès
        if (this.uploadProgress[file.name]?.status === 'success') {
          continue;
        }

        this.uploadProgress[file.name] = { status: 'uploading', progress: 0 };
        
        try {
          const uploadData = {
            company_id: this.invoiceData.company_id,
            file: file
          };
          
          const response = await usePostFile('invoice/upload', uploadData, token);

          if (response && response.status === 200) {
            const result = response.data || {};
            this.uploadProgress[file.name] = {
              status: 'success',
              progress: 100,
              alreadyExists: result.already_exists === true,
              company: result.company || null
            };
            successCount++;
          } else {
            this.uploadProgress[file.name] = { status: 'error', progress: 0 };
          }
        } catch (error) {
          console.error('Upload error:', error);
          this.uploadProgress[file.name] = { status: 'error', progress: 0 };
        }
      }

      this.isUploading = false;
      // Les fichiers importés restent affichés avec leur résultat (company détectée, importé/déjà existant)
    },
    resetForm() {
      this.selectedFiles = [];
      this.uploadProgress = {};
      this.invoiceData.company_id = null;
    },
    handleFileUpload(event) {
      const files = Array.from(event.target.files);
      this.addFiles(files);
    },
    addFiles(files) {
      const pdfFiles = files.filter(file => file.type === 'application/pdf');
      
      // Éviter les doublons
      pdfFiles.forEach(file => {
        const isDuplicate = this.selectedFiles.some(existingFile => 
          existingFile.name === file.name && existingFile.size === file.size
        );
        
        if (!isDuplicate) {
          this.selectedFiles.push(file);
        }
      });
    },
    removeFile(index) {
      this.selectedFiles.splice(index, 1);
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    handleDrop(event) {
      event.preventDefault();
      const files = Array.from(event.dataTransfer.files);
      this.addFiles(files);
    },
    handleDragover(event) {
      event.preventDefault();
    },
    handleDragenter(event) {
      event.preventDefault();
    }
  }
}
</script>
